
import { Vue, Component } from 'vue-property-decorator'
import { mapState } from 'vuex'
import Icon from '~/components/common/icon/Icon.vue'
import BasicModal from '~/components/common/modals/basic/Basic.vue'
import FooterBasic from '~/components/common/modals/basic/FooterBasic.vue'
import Button from '~/components/common/buttons/DashboardButton.vue'
import Radio from '~/components/common/input/Radio.vue'
import CloseCrossCtrl from '~/components/common/ctrls/CloseCrossCtrl.vue'

@Component({
  name: 'GoalAndStreakModal',
  components: {
    Icon,
    BasicModal,
    FooterBasic,
    Button,
    Radio,
    CloseCrossCtrl
  },
  computed: {
    ...mapState('gameStreak', ['goals'])
  }
})
export default class GoalAndStreakModal extends Vue {
  isSending = false
  goals

  private selected = this.$store.getters['gameStreak/selectedGoal']

  private mixpanelTrack() {
    const streakName = this.goals[this.selected].name

    this.$mixpanel.track(this.$mixpanel.events.SET_GOAL_BUTTON_CLICK, {
      [this.$mixpanel.props.GOAL_SET]: streakName
    })
    // @ts-ignore
    this.$mixpanel.updateUserInfo({
      Goal: streakName
    })
  }

  private setGoal(close) {
    this.isSending = true

    this.$store.dispatch('gameStreak/changeStreak', { goalCnt: this.selected + 1 })
      .then(close)
      .then(this.mixpanelTrack)
      .catch(this.$sentry.captureException)
      .finally(() => (this.isSending = false))
  }

  close() {
    this.$emit('close')
  }
}
